/**
 * The common field library — every form loads its fields through here, the
 * way uKnowva pages call UKnowvaUI::loadFormField. Built-in types register
 * on import; a module adds its own with registerFieldType().
 */
import { attachmentTypes } from './files/AttachmentField';
import { fileTypes } from './files/FileField';
import { imageTypes } from './files/ImageField';
import { registerFieldType } from './registry';
import { choiceTypes } from './types/choice';
import { dateTypes } from './types/date';
import { pickerTypes } from './types/pickers';
import { secretTypes } from './types/secret';
import { tagTypes } from './types/tags';
import { textTypes } from './types/text';
import { toggleTypes } from './types/toggle';

for (const group of [textTypes, choiceTypes, toggleTypes, dateTypes, tagTypes, secretTypes, pickerTypes,
                     fileTypes, imageTypes, attachmentTypes]) {
  for (const [type, spec] of Object.entries(group)) registerFieldType(type, spec);
}

export { BASE_FIELD_DEFAULTS, FieldDefaultsProvider, useFieldDefaults, type FieldDefaults } from './defaults';
export { FieldValue } from './FieldValue';
export { FormField, type FormFieldProps } from './FormField';
export { FormFields, type FormFieldsProps } from './FormFields';
export { registerFieldType } from './registry';
export { valueAt, withValueAt } from './resolve';
export { textFieldProps } from './textFieldProps';
export type {
  Dynamic, FieldComponentProps, FieldDef, FieldOption, FieldTypeSpec, FieldValidation, FieldValues, GridSpan,
  ResolvedField,
} from './types';
export { useFieldForm, type FieldForm } from './useFieldForm';
export { validateFields, type FieldErrors } from './validate';
export { FileRefLinks, type AttachmentConfig } from './files/AttachmentField';
export { FileList, type FileListItem } from './files/FileList';
export { daysLeft, RecentlyRemoved } from './files/RecentlyRemoved';
export type { FileConfig } from './files/FileField';
export type { ImageConfig } from './files/ImageField';
export { formatBytes } from './types/text';
